export const RECURSO_VISUALIZAR_ATEND_URI = 'Visualizar lista de atendimento'
export const RECURSO_VISUALIZAR_PRONTUARIO_URI = 'Visualizar prontuário'
export const RECURSO_REGISTRAR_ATENDIMENTO_URI = `${RECURSO_VISUALIZAR_ATEND_URI}/Registrar atendimento`
export const RECURSO_CUIDADO_COMPARTILHADO_URI = `Cuidado Compartilhado`
export const RECURSO_VISUALIZAR_DISCUSSAO_URI = `${RECURSO_CUIDADO_COMPARTILHADO_URI}/Visualizar discussão`
